<template>
  <label class="uk-margin" v-bind:for="name">
    <div class="uk-form-label uk-display-block" v-bind:for="name">
      <span v-html="label"></span>{{ required ? '*' : '' }}
    </div>

    <div class="kmc-field-help-text" v-if="helpText" v-html="helpText">
    </div>

    <label class="kmc-input kmc-input-text">
      <span class="prefix">
      </span>
      <input
          ref="input"
          :name="name"
          :id="name"
          :type="'text'"
          :value="inputValue"
          @input="handleChange1"
          @blur="handleBlur1"
          maxlength="8"
          minlength="6"
      />
      <div class="border"></div>
      <span class="suffix"></span>
    </label>

    <div class="kmc-field-error-text">
      {{ errorMessage }}
    </div>

  </label>

</template>

<script>

import {ref, watch} from 'vue'
import {useField} from "vee-validate";

export default {
  name: "KmcInputPostcode",
  components: {},
  props: {
    helpText: {
      type: String,
    },
    value: {
      type: String
    },
    name: {
      type: String,
      default: "field name"
    },
    label: {
      type: String,
      default: "missing label"
    },
    required: {}
  },
  setup: function (props, context) {

    const input = ref(null)

    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(props.name, undefined, {
      initialValue: props.value,
    });

    watch(errorMessage, (current, previous) => {
      input.value.setCustomValidity(current || '');
    })

    let handleChange1 = (e) => {
      let v = input.value.value.replace(/\s/g, '');

      if (v.length >= 4) {
        v = v.substr(0, v.length - 3) + ' ' + v.substr(-3);
      }
      input.value.value = v.toUpperCase();

      handleChange(e);
    }

    let handleBlur1 = (e) => {
      return handleBlur(e);
    }

    return {
      input,
      handleChange1,
      handleBlur1,
      errorMessage,
      inputValue,
      meta,
    };
  }
}

</script>

